const selector = "[data-enable]"

document.addEventListener("DOMContentLoaded", (e) => {
  const elements = document.querySelectorAll(selector)

  elements.forEach((element) => {
    element.disabled = false
  })
})
